export interface GrantProgramInstance {
  program: number
  year: number
  revision: number
}

export interface GrantEligibilityOption {
  benefitProgramInstance: GrantProgramInstance
  isEligible: boolean
  eligibleAmount: number
}

export interface ExistingGrantOption {
  benefitProgramInstance: GrantProgramInstance
}

export function grantInstanceKey(instance: GrantProgramInstance): string {
  return `${instance.program}:${instance.year}:${instance.revision}`
}

export function availableGrantEligibility<T extends GrantEligibilityOption>(
  eligibility: readonly T[],
  grants: readonly ExistingGrantOption[],
  selectableProgramIds: ReadonlySet<number>,
): T[] {
  return eligibility.filter((option) =>
    option.isEligible &&
    selectableProgramIds.has(option.benefitProgramInstance.program) &&
    !grants.some((grant) =>
      grant.benefitProgramInstance.program === option.benefitProgramInstance.program &&
      grant.benefitProgramInstance.year === option.benefitProgramInstance.year,
    ),
  )
}

export function isGrantEntryEditable(proofingStatus: number, canEditProtectedLifecycle: boolean): boolean {
  return proofingStatus === 0 || proofingStatus === 255 ||
    (canEditProtectedLifecycle && (proofingStatus === 5 || proofingStatus === 10 || proofingStatus === 30))
}

export function grantDefaults(applicationDate: string, eligibleAmount: number) {
  return {
    applicationDate: applicationDate.slice(0, 10),
    grantAmount: String(eligibleAmount),
  }
}
